import { DatePicker, DatePickerProps } from 'antd'
import clsx from 'clsx'
import dayjs from 'dayjs'
import React from 'react'

import styles from './pure-date-picker.module.scss'

type PureDatePickerProps = {
  label?: string
  colClass?: string
  moduleStyle?: string
  required?: boolean
  value?: string | Date | null
  onChange?: (value: any) => void
  onBlur?: (value: any) => void
  name?: string
} & Omit<DatePickerProps, 'value' | 'onChange' | 'onBlur'>

export const PureDatePicker = ({
  label,
  id,
  onBlur,
  colClass,
  moduleStyle,
  onChange,
  required = false,
  value,
  name,
  ...rest
}: PureDatePickerProps) => {
  const formattedValue = value && dayjs(value).isValid() ? dayjs(value) : null

  const handleAntdChange = (date: dayjs.Dayjs | null) => {
    const valueToSend = date && date.isValid() ? date.format('YYYY-MM-DD') : null

    if (onChange) {
      onChange({
        persist: () => {},
        target: {
          name: name,
          value: valueToSend,
        },
      })
    }
  }

  const handleAntdBlur = (e: any) => {
    if (!onBlur) return

    onBlur({
      persist: () => {},
      target: {
        name: name,
        id: id || name, // Явно передаем имя поля, чтобы Formik понял, кто вызвал blur
      },
    })
  }

  return (
    <div className={clsx(colClass || 'col-12', moduleStyle || '', styles.datePickerStyles)}>
      {label ? (
        <div className="label d-block mt-2 mb-1">
          {label}
          {required ? <span className={clsx('requiredAsterisk')}>*</span> : null}
        </div>
      ) : null}
      <DatePicker
        {...rest}
        format="YYYY-MM-DD"
        id={id || name}
        name={name}
        onBlur={handleAntdBlur}
        onChange={handleAntdChange}
        value={formattedValue} // Контролируемое значение от Formik
      />
    </div>
  )
}
